import React, { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Button, Callout, Input, toast } from '@node-space/ui-components'
import { useAccountPreferenceMutation } from 'hooks/mutations/useAccountPreferenceMutation'

interface EditCompanyProfileProps {
  description: string
}

const EditCompanyProfile = ({ description }: EditCompanyProfileProps) => {
  const { t } = useTranslation()
  const action = useAtomValue(actionAtom)
  const queryClient = useQueryClient()
  const { mutate: updateCompanyInfoPreference, isPending: isUpdatingCompanyInfo } =
    useAccountPreferenceMutation<string>()
  const [companyInfoDescription, setCompanyInfoDescription] = useState(
    action?.meta?.companyDetails?.description
  )

  const onCompanyInfoUpdate = async () => {
    updateCompanyInfoPreference(
      { preferenceKey: 'companyDescription', value: companyInfoDescription },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ['accountPreferences'] })
          toast({ header: t('bvnkNetwork.detailsUpdatedSuccessfully'), variant: 'success' })
          action?.onClose?.()
        },
        onError: () => {
          toast({ header: t('bvnkNetwork.detailsUpdatedError'), variant: 'error' })
        },
      }
    )
  }

  const onCompanyDescriptionChange = (value: string) => {
    setCompanyInfoDescription(value)
  }

  return (
    <Box flexCol gapY={20} padding={24}>
      <Input
        onChange={e => onCompanyDescriptionChange(e?.target?.value)}
        label={t('bvnkNetwork.companyDescription')}
        inputMode="text"
        name="companyDescription"
        value={companyInfoDescription}
      />
      {/* TODO: Implement logo upload */}
      <Callout variant="info">{t('bvnkNetwork.editCompanyNameCallout')}</Callout>

      <Button
        disabled={companyInfoDescription === description || !companyInfoDescription}
        loading={isUpdatingCompanyInfo}
        testId="save-company-info"
        onClick={onCompanyInfoUpdate}
      >
        {t('bvnkNetwork.saveChanges')}
      </Button>
    </Box>
  )
}

export default EditCompanyProfile
